var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo-gallery-collage"},[_c('button',{staticClass:"view-all"},[_vm._v("View All Images")]),_vm._v(" "),_c('picture',{staticClass:"collage-picture--0"},[_c('img',{attrs:{"width":"600","height":"400","alt":_vm.imageOne.title,"src":_vm.getContentfulImgURL({
      url: _vm.imageOne.url,
      width: 900,
      quality: 80,
    })}}),_vm._v(" "),_c('div',{staticClass:"desktop-image-caption"},[_c('span',[_vm._v("\n        "+_vm._s(_vm.imageOne.title)+"\n      ")])])]),_vm._v(" "),_c('picture',{staticClass:"collage-picture--1"},[_c('img',{staticClass:"lazyload",attrs:{"width":"600","height":"400","src":_vm.getContentfulImgURL({
      url: _vm.imageTwo.url,
      width: 600,
      quality: 10
    }),"data-src":_vm.getContentfulImgURL({
      url: _vm.imageTwo.url,
      width: 600,
      quality: 80
    })}})]),_vm._v(" "),_c('picture',{staticClass:"collage-picture--2"},[_c('img',{staticClass:"lazyload",attrs:{"width":"600","height":"400","src":_vm.getContentfulImgURL({
      url: _vm.imageThree.url,
      width: 400,
      quality: 10
    }),"data-src":_vm.getContentfulImgURL({
      url: _vm.imageThree.url,
      width: 400,
      quality: 80
    })}})]),_vm._v(" "),_c('picture',{staticClass:"collage-picture--3"},[_c('img',{staticClass:"lazyload",attrs:{"width":"600","height":"400","src":_vm.getContentfulImgURL({
      url: _vm.imageFour.url,
      width: 400,
      quality: 10
    }),"data-src":_vm.getContentfulImgURL({
      url: _vm.imageFour.url,
      width: 400,
      quality: 80
    })}})])])}
var staticRenderFns = []

export { render, staticRenderFns }